import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import withRouter from 'withRouter';
import withStyles from '@mui/styles/withStyles';
import {
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableFooter,
  TablePagination,
  Badge,
  Tooltip,
  IconButton,
  ToggleButton,
  Typography,
  ToggleButtonGroup,
} from '@mui/material';
import { Picky } from 'react-picky';
import 'react-picky/dist/picky.css';
import FilterData from '../../component/filterData';
import '../../styles/dashboard/dashboard.scss';
import {
  resetErrorMessage,
  resetSuccessMessage,
} from '../../../userOnBoarding/actions/actions';
import '../../styles/inbox/inbox.scss';
import {
  getDashboardTab,
  getDashboardTabData,
  getMyAllReportee,
  getReportDetails,
  clearDashboardData,
  getTeamDesignations,
} from '../../actions/report';
import {
  getTeamUserDetails,
  getUserDesignationDetails,
} from '../../actions/home';
import moment from 'moment';
import { isNull, dateFilterFormater, decodeAccessToken } from 'utils/helper';

const styles = {
  badge: {
    backgroundColor: '#4a90e2',
    color: '#ffffff',
  },
  root: {
    marginRight: 35,
  },
};

const dashboardDefaultFilters = [
  {
    type: 'date',
    name: '_mo_created_at',
    label: 'Recorded Date',
    value: 'Last 30 days',
    options: [
      'None',
      'Today',
      'Yesterday',
      'Current month',
      'Last 30 days',
      'Last 60 days',
      'Last 90 days',
      'Custom',
    ],
  },
];

class Dashboard extends Component<any, any> {
  private filterDataRef = React.createRef<FilterData>();
  state = {
    activeTab: '',
    page: 0,
    rowsPerPage: 10,
    selectedView: { name: '', label: '' },
    headers: [{ label: 'Created At' }, { label: 'Status' }, { label: 'Owner' }],
    showInboxTable: false,
    openFilter: true,
    filterCount: 1,
    selectedFilter: {
      defaultFilter: [],
      userFilter: [],
    },
    tableData: [],
    viewMode: 'TEAM',
    didPrimeCreatedAt: false,
    dashboardTab: [] as any[],
    dashboardTabData: [] as any[],
  };

  componentDidMount() {
    const locState = this.props.router.location?.state || {};
    const isFromSummary = locState.fromSummary === true;
    if (locState.returnPath == 'home') {
      localStorage.clear();
    }
    if (isFromSummary) {
      const prevViewMode = locState.previousViewState?.viewMode;
      if (prevViewMode) {
        this.setState({ viewMode: prevViewMode });
      }
    } else {
      this.setState({ viewMode: 'TEAM' });
    }
    if (!sessionStorage.getItem('reload-handled')) {
      const navEntry = performance.getEntriesByType(
        'navigation'
      )[0] as PerformanceNavigationTiming;
      const isReload = navEntry?.type === 'reload';

      if (isReload) {
        localStorage.clear();
        this.handlePageReload();
      }
      sessionStorage.setItem('reload-handled', 'true');
    }

    const saved = this.loadDashboardState();
    const userFilter = saved?.selectedFilter?.userFilter || [];

    if (saved) {
      this.setState(
        {
          selectedView: saved.selectedView || this.state.selectedView,
          viewMode: saved.viewMode || this.state.viewMode,
          filterCount: userFilter.filter((f: any) => f.value !== null).length,
          selectedFilter: saved.selectedFilter || this.state.selectedFilter,
        },
        () => {
          if (this.filterDataRef.current) {
            const fd = this.filterDataRef.current;
            fd.setState((s: any) => {
              let updatedTabs = [...s.tabs];
              let otherDateFilterExists = false;

              userFilter.forEach((savedFilter: any) => {
                const tabIndex = updatedTabs.findIndex(
                  (tab: any) => tab.name === savedFilter.name
                );

                let displayValue = savedFilter.value;
                if (
                  savedFilter.type === 'date' &&
                  savedFilter.value &&
                  savedFilter.value.length > 0
                ) {
                  const dateRange = savedFilter.value[0];
                  if (
                    typeof dateRange === 'object' &&
                    dateRange !== null &&
                    'from' in dateRange &&
                    'to' in dateRange
                  ) {
                    const defaultDateOptions =
                      dashboardDefaultFilters.find(
                        (f) => f.name === '_mo_created_at'
                      )?.options || [];
                    let matchedOption = null;
                    for (const option of defaultDateOptions) {
                      if (option === 'None' || option === 'Custom') continue;
                      const mappedRange = dateFilterFormater(option);
                      if (
                        mappedRange &&
                        mappedRange.from === dateRange.from &&
                        mappedRange.to === dateRange.to
                      ) {
                        matchedOption = option;
                        break;
                      }
                    }
                    displayValue = matchedOption || 'Custom';
                  } else {
                    displayValue = savedFilter.value[0];
                  }
                  if (
                    savedFilter.value === null ||
                    savedFilter.value.length === 0
                  ) {
                    displayValue = null;
                  }
                }
                if (
                  savedFilter.type === 'date' &&
                  savedFilter.name !== '_mo_created_at' &&
                  savedFilter.value !== null &&
                  savedFilter.value.length > 0
                ) {
                  otherDateFilterExists = true;
                }

                if (tabIndex > -1) {
                  updatedTabs[tabIndex] = {
                    ...updatedTabs[tabIndex],
                    value: displayValue,
                  };
                }
              });
              if (otherDateFilterExists) {
                updatedTabs = updatedTabs.map((tab: any) => {
                  if (tab.name === '_mo_created_at') {
                    return { ...tab, value: null };
                  }
                  return tab;
                });
              }

              return { tabs: updatedTabs };
            });
            this.setState({ didPrimeCreatedAt: true });
          }
        }
      );
    } else {
      this.primeCreatedAtUI();
    }

    this.restoreViewIfReturning();
    const desigId = this.getDesignationId();
    if (desigId) {
      this.props.getMyAllReportee(desigId);
    }

    const { templateId, teamId } = this.props.router?.params || {};
    if (templateId && teamId) {
      this.props.clearDashboardData();
      this.bootstrapData();
    }
  }

  componentDidUpdate(prevProps: any) {
    const oldTpl = prevProps.router.params.templateId;
    const newTpl = this.props.router.params.templateId;
    if (newTpl && newTpl !== oldTpl) {
      this.setState({
        activeTab: '',
        selectedView: { name: '', label: '' },
        tableData: [],
        page: 0,
        rowsPerPage: 10,
        filterCount: 1,
        selectedFilter: { defaultFilter: [], userFilter: [] },
        didPrimeCreatedAt: false,
      });
      this.props.clearDashboardData();
      this.bootstrapData();
      return;
    }

    this.primeCreatedAtUI();
    this.selectTabWhenTabsArrive(prevProps);
    this.syncTableData(prevProps);
    this.syncReportees(prevProps);
    this.syncDesignationDetails(prevProps);
  }

  componentWillUnmount() {
    this.props.clearDashboardData();
  }

  handlePageReload = () => {
    this.clearFilters();
    this.setState({ openFilter: true });
  };

  bootstrapData = () => {
    const { templateId, teamId } = this.props.router?.params || {};
    if (!templateId || !teamId) return;

    const userId = sessionStorage.getItem('userId') || '';
    this.props.getTeamUserDetails(teamId, userId);
    this.props.getDashboardTab(templateId, teamId);
    this.props.getReportDetails(templateId, teamId);
  };

  restoreViewIfReturning = () => {
    const locationState = this.props.router?.location?.state;
    if (
      locationState?.returnPath !== 'dashboard' ||
      !locationState.previousViewState
    )
      return;

    this.setState(
      {
        ...locationState.previousViewState,
        showInboxTable: false,
      },
      () => this.selectTab(this.state.activeTab)
    );
  };

  selectDefaultTabIfReady = () => {
    if (this.props.dashboardTab?.length) {
      this.selectTab(this.props.dashboardTab[0].name);
    }
  };

  selectTabWhenTabsArrive = (prevProps: any) => {
    const tabsLoadedNow =
      !prevProps.dashboardTab?.length && this.props.dashboardTab?.length;

    const saved = this.loadDashboardState();
    const savedSelectedViewName = saved?.selectedView?.name;

    if (tabsLoadedNow) {
      if (savedSelectedViewName) {
        const savedTab = this.props.dashboardTab.find(
          (t: any) => t.name === savedSelectedViewName
        );
        if (savedTab) {
          this.selectTab(savedTab.name);
          return;
        }
      }
      if (this.props.dashboardTab[0]) {
        this.selectTab(this.props.dashboardTab[0].name);
      }
    }
  };

  syncTableData = (prevProps: any) => {
    if (prevProps.dashboardTabData === this.props.dashboardTabData) return;
    this.setState({
      rawData: this.props.dashboardTabData,
      tableData: this.props.dashboardTabData,
      page: 0,
    });
  };

  syncReportees = (prevProps: any) => {
    const prevId = prevProps.userTeamDetails?.designation?.designation_id;
    const currId = this.props.userTeamDetails?.designation?.designation_id;
    const { templateId, teamId } = this.props.router?.params || {};

    if (currId && currId !== prevId && templateId && teamId) {
      this.props.getMyAllReportee(currId);
    }
  };

  syncDesignationDetails = (prevProps: any) => {
    const successNow =
      this.props.teamUserDetailsSuccess &&
      prevProps.teamUserDetailsSuccess !== this.props.teamUserDetailsSuccess;

    if (successNow) {
      const desigId = this.props.userTeamDetails?.designation?.designation_id;
      desigId && this.props.getUserDesignationDetails(desigId);
      const { teamId } = this.props.router?.params || {};
      if (teamId) this.props.getTeamDesignations(teamId);
    }
  };

  selectTab = (name?: string) => {
    if (!this.props.dashboardTab?.length) return;
    const tab =
      this.props.dashboardTab.find((t: any) => t.name === name) ??
      this.props.dashboardTab[0];
    tab && this.handleTabChange(tab);
  };

  handleRowClick = (row: any) => {
    const { templateId, teamId } = this.props.router?.params || {};
    const targetId = row._id || row.dimension?._id;
    const gk = encodeURIComponent(JSON.stringify({ _id: targetId }));
    const dashboardName = this.state.selectedView?.name;
    const { query, from: filterFrom, to: filterTo } = this.buildBackendFilter();

    const currentState = {
      activeTab: this.state.activeTab,
      selectedView: this.state.selectedView,
      viewMode: this.state.viewMode,
      filterFrom: filterFrom,
      filterTo: filterTo,
      filterQuery: query,
    };

    this.setState(
      {
        showInboxTable: true,
        selectedRowData: row,
        selectedGK: gk,
        previousViewState: currentState,
      },
      () => {
        this.persistDashboardState();
        this.props.router.navigate(
          `/member/${teamId}/dashboard/${templateId}/details/${dashboardName}/${gk}`,
          {
            state: {
              returnPath: 'dashboard',
              previousViewState: currentState,
              totalCount: row.total_count,
              filterFrom: filterFrom,
              filterTo: filterTo,
              filterQuery: query,
            },
          }
        );
      }
    );
  };

  fetchDataForCurrentView = () => {
    const { templateId, teamId } = this.props.router?.params || {};
    const { selectedView } = this.state;
    const dashboardTab = Array.isArray(this.props.dashboardTab)
      ? this.props.dashboardTab
      : [];

    if (
      !templateId ||
      !teamId ||
      !selectedView?.name ||
      dashboardTab.length === 0
    )
      return;

    const tab = dashboardTab.find((t) => t.name === selectedView.name);
    if (!tab) return;

    const designationId = this.getDesignationId();

    let defaultDateRange: any = null;

    defaultDateRange = dateFilterFormater('last 30 days');

    const {
      query,
      from: fromTimestamp,
      to: toTimestamp,
      dk,
    } = this.buildBackendFilter();

    this.props.getDashboardTabData({
      templateId: templateId || tab.template_id,
      dashboardName: tab.name,
      from:
        fromTimestamp ||
        (defaultDateRange
          ? moment(defaultDateRange.from).valueOf()
          : undefined),
      to:
        toTimestamp ||
        (defaultDateRange ? moment(defaultDateRange.to).valueOf() : undefined),
      dateKey: dk,
      designationId,
      filter: query,
      reportees: this.getReporteesParam(),
      teamId,
    });
  };

  persistDashboardState = () => {
    const { templateId } = this.props.router.params || {};
    if (!templateId) return;

    const { selectedView, viewMode, tableData, page, rowsPerPage } = this.state;

    localStorage.setItem(
      `dashboard_state_${templateId}`,
      JSON.stringify({
        selectedView,
        viewMode,
        tableData,
        page,
        rowsPerPage,
        selectedFilter: this.state.selectedFilter,
      })
    );
  };

  loadDashboardState = () => {
    const { templateId } = this.props.router.params || {};
    if (!templateId) return null;
    try {
      const storedState = localStorage.getItem(`dashboard_state_${templateId}`);
      return storedState ? JSON.parse(storedState) : null;
    } catch {
      return null;
    }
  };
  handleChangeOpenFilter = () => {
    this.setState({ openFilter: !this.state.openFilter });
  };

  getReporteesParam = () => (this.state.viewMode === 'TEAM' ? 'ALL' : 'NONE');

  handleTabChange = (tab: any) => {
    const { templateId, teamId } = this.props.router?.params || {};
    const designationId = this.getDesignationId();

    if (!tab || !templateId || !teamId) return;

    let defaultDateRange: any = null;

    defaultDateRange = dateFilterFormater('last 30 days');

    const {
      query,
      from: fromTimestamp,
      to: toTimestamp,
      dk,
    } = this.buildBackendFilter();

    const dynamicFilterMap = this.getAllDynamicFiltersMap();
    const dynamicFields = dynamicFilterMap[tab.name] || [];

    this.setState({
      activeTab: tab.name,
      selectedView: { name: tab.name, label: tab.label || tab.name },
      dynamicFilterFields: dynamicFields,
      page: 0,
    });
    this.props.getDashboardTabData({
      templateId: templateId || tab.template_id,
      dashboardName: tab.name,
      from:
        fromTimestamp ||
        (defaultDateRange
          ? moment(defaultDateRange.from).valueOf()
          : undefined),
      to:
        toTimestamp ||
        (defaultDateRange ? moment(defaultDateRange.to).valueOf() : undefined),
      dateKey: dk,
      designationId,
      filter: query,
      reportees: this.getReporteesParam(),
      teamId,
    });
  };

  getDimensionValue = (tabDetails: any, item: any) => {
    const dimension = item.dimension ? item.dimension : null;
    if (!dimension) return '';
    switch (dimension.t && dimension.t.toLowerCase()) {
      case 'date':
        return tabDetails.frequency === 'MONTHLY'
          ? moment(dimension.v).format('MMM - YYYY')
          : moment(dimension.v).format('MMM Do');
      case 'user':
      case 'designation':
        const obj = this.props.allReportee.find(
          (rep: any) => rep.designation_id === dimension.v
        );
        return obj
          ? `${obj.designation_name || ''} (${obj.user_alias || ''})`
          : '';
      default:
        return typeof dimension.v !== 'object' ? dimension.v : '';
    }
  };

  getDesignationDisplayName = (designationId: string) => {
    const { allReportee, userTeamDetails } = this.props;
    if (userTeamDetails?.designation?.designation_id === designationId) {
      const alias =
        userTeamDetails.user_alias ||
        userTeamDetails.user?.user_alias ||
        userTeamDetails.user_name;
      return `${userTeamDetails.designation.designation_name || ''} (${alias})`;
    }

    const match = allReportee?.find(
      (rep: any) =>
        rep.designation_id === designationId ||
        rep.desig_id === designationId ||
        rep._id === designationId
    );

    if (!match) return '';

    const alias =
      match.user_alias ||
      match.user?.user_alias ||
      match.user_name ||
      match.user?.user_name;

    return `${match.designation_name || ''} (${alias || '—'})`;
  };

  getDesignationId = () => {
    const token = sessionStorage.getItem('accessToken');
    if (!token) return null;
    try {
      const payload = decodeAccessToken(token);
      return payload.did || null;
    } catch {
      return null;
    }
  };

  handleFilterChange = (data: any, selected?: any) => {
    const isDashboardContext = data.isDashboardContext === true;

    const isDateFieldMeta = (fieldMeta: any) =>
      (fieldMeta.t || '').toLowerCase() === 'date';

    const getFieldMeta = (fieldName: string) => {
      let fieldMeta = (this.props.reportDetails?.dimensions || []).find(
        (d: any) => d.k === fieldName || d.name === fieldName
      );
      if (!fieldMeta && fieldName === '_mo_created_at') {
        fieldMeta = { k: fieldName, t: 'date', l: 'Created At' };
      }
      return fieldMeta;
    };

    if (typeof data === 'object' && data !== null && data.type === 'clear') {
      this.clearFilters();
      return;
    }

    if (
      typeof data === 'object' &&
      data !== null &&
      data.type === 'apply_structured'
    ) {
      const { filters } = data;
      let updatedUserFilter: any[] = [];
      let newOrUpdatedDashboardDateFilter: any | null = null;

      this.setState(
        (prev: any) => {
          let baseUserFilter = prev.selectedFilter.userFilter.filter(
            (f: any) => {
              return !filters.hasOwnProperty(f.name) && f.type !== 'date';
            }
          );

          if (!isDashboardContext) {
            prev.selectedFilter.userFilter.forEach((f: any) => {
              if (f.type === 'date' && !filters.hasOwnProperty(f.name)) {
                baseUserFilter.push(f);
              } else if (
                f.type === 'date' &&
                filters.hasOwnProperty(f.name) &&
                (filters[f.name] === null ||
                  (Array.isArray(filters[f.name]) &&
                    filters[f.name].length === 0))
              ) {
              }
            });
          }
          updatedUserFilter = baseUserFilter;

          Object.entries(filters).forEach(
            ([fieldName, selectedValue]: [string, any]) => {
              if (fieldName === '_mo_updated_at') {
                return;
              }

              const isClearAction =
                selectedValue == null ||
                (Array.isArray(selectedValue) && selectedValue.length === 0);

              if (isClearAction) {
                updatedUserFilter = updatedUserFilter.filter(
                  (f) => f.name !== fieldName
                );
              } else {
                const fieldMeta = getFieldMeta(fieldName);
                if (fieldMeta) {
                  const valueArr = Array.isArray(selectedValue)
                    ? selectedValue
                    : [selectedValue];

                  if (
                    isDateFieldMeta(fieldMeta) &&
                    typeof valueArr[0] === 'string'
                  ) {
                    const mapped = dateFilterFormater(valueArr[0]);
                    if (mapped) valueArr[0] = mapped;
                  }

                  const type = isDateFieldMeta(fieldMeta)
                    ? 'date'
                    : (fieldMeta.t || '').toLowerCase().includes('status')
                      ? 'status_picker'
                      : 'picker';

                  const filterItem = {
                    name: fieldMeta.k,
                    type,
                    label: fieldMeta.l,
                    value: valueArr,
                  };

                  if (filterItem.type === 'date') {
                    if (isDashboardContext) {
                      newOrUpdatedDashboardDateFilter = filterItem;
                    } else {
                      updatedUserFilter = updatedUserFilter.filter(
                        (f) => f.name !== filterItem.name
                      );
                      updatedUserFilter.push(filterItem);
                    }
                  } else {
                    updatedUserFilter = updatedUserFilter.filter(
                      (f) => f.name !== filterItem.name
                    );
                    updatedUserFilter.push(filterItem);
                  }
                }
              }
            }
          );

          if (isDashboardContext) {
            if (newOrUpdatedDashboardDateFilter) {
              updatedUserFilter = updatedUserFilter.filter(
                (f) => f.type !== 'date'
              );
              updatedUserFilter.push(newOrUpdatedDashboardDateFilter);
            } else {
              updatedUserFilter = updatedUserFilter.filter(
                (f) => f.type !== 'date'
              );
            }
            if (this.filterDataRef.current) {
              this.filterDataRef.current.setState((s: any) => ({
                tabs: s.tabs.map((tab: any) => {
                  if (
                    tab.type === 'date' &&
                    tab.name !== newOrUpdatedDashboardDateFilter?.name
                  ) {
                    return { ...tab, value: null };
                  }
                  return tab;
                }),
              }));
            }
          } else {
          }

          return {
            selectedFilter: {
              ...prev.selectedFilter,
              userFilter: updatedUserFilter,
            },
            filterCount: updatedUserFilter.filter((f: any) => f.value !== null)
              .length,
            page: 0,
          };
        },
        () => {
          this.fetchDataForCurrentView();
        }
      );
      return;
    }

    if (data === '_mo_updated_at') {
      return;
    }

    const isClearAction =
      selected == null || (Array.isArray(selected) && selected.length === 0);

    this.setState(
      (prev: any) => {
        let userFilter = prev.selectedFilter.userFilter.filter(
          (f: any) => f.name !== data
        );

        if (isClearAction) {
          return {
            selectedFilter: {
              ...prev.selectedFilter,
              userFilter: userFilter,
            },
            filterCount: userFilter.filter((f: any) => f.value !== null).length,
            page: 0,
          };
        }

        const fieldMeta = getFieldMeta(data);
        if (!fieldMeta) {
          return prev;
        }

        const valueArr = Array.isArray(selected) ? selected : [selected];
        if (isDateFieldMeta(fieldMeta) && typeof valueArr[0] === 'string') {
          const mapped = dateFilterFormater(valueArr[0]);
          if (mapped) valueArr[0] = mapped;
        }

        const type = isDateFieldMeta(fieldMeta)
          ? 'date'
          : (fieldMeta.t || '').toLowerCase().includes('status')
            ? 'status_picker'
            : 'picker';

        const filterItem = {
          name: fieldMeta.k,
          type,
          label: fieldMeta.l,
          value: valueArr,
        };

        if (filterItem.type === 'date') {
          if (isDashboardContext) {
            userFilter = userFilter.filter((f: any) => f.type !== 'date');

            if (this.filterDataRef.current) {
              this.filterDataRef.current.setState((s: any) => ({
                tabs: s.tabs.map((tab: any) => {
                  if (tab.type === 'date' && tab.name !== filterItem.name) {
                    return { ...tab, value: null };
                  }
                  return tab;
                }),
              }));
            }
          }
        }

        userFilter = [...userFilter, filterItem];

        return {
          selectedFilter: { ...prev.selectedFilter, userFilter },
          filterCount: userFilter.filter((f: any) => f.value !== null).length,
          page: 0,
        };
      },
      () => {
        this.fetchDataForCurrentView();
      }
    );
  };

  getDashboardDk = (dateObj: { name: string } | null): string => {
    const dimensionsRaw = this.props.reportDetails?.dimensions || [];

    const dimensions = dimensionsRaw.map((d: any) => ({
      name: d.k,
      m: d.m,
    }));

    if (dateObj) {
      const match = dimensions.find((dim: any) => dim.name === dateObj.name);
      if (match?.m) return match.m;
    }

    return 'recorded_date';
  };

  mergeSelectedAndDefaultFilter = (user: any[] = [], def: any[] = []) => {
    const namesInUser = user.map((f) => f.name);
    const extra = def.filter((f) => !namesInUser.includes(f.name));
    return [...user, ...extra];
  };

  getSingleArrayFromAllFilter = (filterObj: any) => {
    if (isNull(filterObj)) return [];

    const { userFilter = null, defaultFilter = null } = filterObj;

    const effectiveDefaultFilter = defaultFilter || dashboardDefaultFilters;

    if (userFilter && effectiveDefaultFilter)
      return this.mergeSelectedAndDefaultFilter(
        userFilter,
        effectiveDefaultFilter
      );
    if (userFilter) return userFilter;
    if (effectiveDefaultFilter) return effectiveDefaultFilter;
    return [];
  };

  autoUpdateFilterDate = (values: any[]) => values;

  getDashboardV2FilterQuery = (
    dimensions: Array<{ name: string; type?: string; m?: string }>,
    combinedFilter: any[]
  ) => {
    const nonDateDimensions = dimensions.filter(
      (d: any) => d.t?.toLowerCase() !== 'date'
    );
    const nonDateDimensionNames = nonDateDimensions.map((d) => d.name);

    let qs = '';

    nonDateDimensionNames.forEach((fname) => {
      const filt = combinedFilter.find((f) => f.name === fname);
      if (!filt || isNull(filt.value)) return;

      if (fname === '_mo_updated_at') {
        return;
      }

      const dim = nonDateDimensions.find((d) => d.name === fname);
      const name = dim?.m || fname;
      const { type, value } = filt;
      let part = '';

      switch (type) {
        case 'date':
          break;
        case 'picker':
        case 'status_picker':
          part = `${name}=${value}`;
          break;
        default:
          break;
      }

      if (part) qs += (qs ? '&' : '') + part;
    });

    return qs;
  };

  buildBackendFilter = () => {
    const dimensionsRaw = this.props.reportDetails?.dimensions || [];
    if (!dimensionsRaw.length)
      return { query: '', from: '', to: '', dk: 'recorded_date' };

    const { selectedFilter } = this.state;
    const combined = this.getSingleArrayFromAllFilter(selectedFilter);
    const dateObj = combined.filter((f: any) => f.type === 'date');

    const dims = (this.props.reportDetails?.dimensions || []).map((d: any) => ({
      name: d.k,
      m: d.m,
      t: d.t,
      l: d.l,
    }));

    const finalQuery = this.getDashboardV2FilterQuery(dims, combined);

    let finalFrom = '';
    let finalTo = '';
    let finalDk = 'recorded_date';

    const hasAnyDate = dateObj.length > 0;

    if (!hasAnyDate) {
      const defaultRange = dateFilterFormater('last 30 days');
      finalFrom = moment(defaultRange.from).valueOf().toString();
      finalTo = moment(defaultRange.to).valueOf().toString();
    } else {
      const dateRanges = dateObj.flatMap((obj: any) =>
        obj.value.map((val: any) => ({
          from: moment(val.from).valueOf(),
          to: moment(val.to).valueOf(),
        }))
      );

      if (dateRanges.length > 0) {
        let latestStart = dateRanges[0].from;
        let earliestEnd = dateRanges[0].to;

        for (let i = 1; i < dateRanges.length; i++) {
          latestStart = Math.max(latestStart, dateRanges[i].from);
          earliestEnd = Math.min(earliestEnd, dateRanges[i].to);
        }

        if (latestStart <= earliestEnd) {
          finalFrom = latestStart.toString();
          finalTo = earliestEnd.toString();
        } else {
          finalFrom = dateRanges[0].from.toString();
          finalTo = dateRanges[0].to.toString();
        }
        finalDk = this.getDashboardDk(dateObj[0]);
      }
    }

    localStorage.setItem(
      `dashboard_query_${this.props.router.params.templateId}`,
      JSON.stringify({
        query: finalQuery,
        from: finalFrom,
        to: finalTo,
        dk: finalDk,
      })
    );
    return { query: finalQuery, from: finalFrom, to: finalTo, dk: finalDk };
  };

  clearFilters = () => {
    this.setState(
      {
        selectedFilter: { defaultFilter: [], userFilter: [] },
        filterCount: 1,
        page: 0,
      },
      () => {
        if (this.filterDataRef.current) {
          this.filterDataRef.current.setState((s: any) => ({
            tabs: s.tabs.map((tab: any) =>
              tab.name === '_mo_created_at'
                ? { ...tab, value: 'Last 30 days' }
                : tab
            ),
          }));
        }
        this.fetchDataForCurrentView();
      }
    );
  };

  handleChangePage = (_: any, page: number) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event: any) => {
    this.setState({ rowsPerPage: event.target.value, page: 0 });
  };

  handleBack = () => {
    localStorage.clear();
    this.setState(
      {
        filterCount: 1,
        selectedFilter: { defaultFilter: [], userFilter: [] },
        viewMode: 'TEAM',
      },
      () => {
        this.setState({ openFilter: false }, () => {
          this.persistDashboardState();
          this.props.router.navigate('/member/home');
        });
      }
    );
  };

  renderHeader = () => {
    const workflowName = this.props.reportDetails?.description || '—';
    return (
      <div className="workflow-inbox-header">
        <div className="workflow-inbox-title-wrapper">
          <i
            className="fas fa-arrow-left"
            style={{ paddingRight: 20, cursor: 'pointer' }}
            onClick={() => {
              this.handleBack();
            }}
          />

          <Tooltip title={workflowName} placement="bottom-start">
            <Typography variant="subtitle1" component="p">
              Dashboard – {workflowName}
            </Typography>
          </Tooltip>
        </div>
      </div>
    );
  };

  handleViewChange = (selectedView: any) => {
    const selectedTab = this.props.dashboardTab.find(
      (t: any) => t.name === selectedView.name
    );
    if (!selectedTab) return;

    const dynamicFilterMap = this.getAllDynamicFiltersMap();
    const dynamicFields = dynamicFilterMap[selectedTab.name] || [];

    const { templateId, teamId } = this.props.router?.params || {};
    const designationId = this.getDesignationId();

    let defaultDateRange: any = null;
    defaultDateRange = dateFilterFormater('last 30 days');
    const {
      query,
      from: fromTimestamp,
      to: toTimestamp,
      dk,
    } = this.buildBackendFilter();
    this.props.getDashboardTabData({
      templateId: templateId || selectedTab.template_id,
      dashboardName: selectedTab.name,
      from:
        fromTimestamp ||
        (defaultDateRange
          ? moment(defaultDateRange.from).valueOf()
          : undefined),
      to:
        toTimestamp ||
        (defaultDateRange ? moment(defaultDateRange.to).valueOf() : undefined),
      dateKey: dk,
      designationId,
      filter: query,
      reportees: this.getReporteesParam(),
      teamId,
    });
    this.setState(
      {
        activeTab: selectedTab.name,
        dynamicFilterFields: dynamicFields,
        selectedView: {
          name: selectedTab.name,
          label: selectedTab.label || selectedTab.name,
        },
        openFilter: true,
      },
      () => this.persistDashboardState()
    );
  };

  getAllDynamicFiltersMap = () => {
    const dashboardTab = this.props.dashboardTab || [];
    if (!dashboardTab.length) {
      return {};
    }
    const dynamicFilterMap: any = {};

    dashboardTab.forEach((tab: any) => {
      try {
        const displayTemplateObj = JSON.parse(tab.display_template || '{}');
        const summaryView = displayTemplateObj.summaryView || {};

        const dynamicFields = Object.entries(summaryView).map(
          ([key, field]: [string, any]) => ({
            key: field.k
              ? field.k.replace('{{data.', '').replace('}}', '')
              : key,
            label: field.l || key,
            type: field.t || 'string',
          })
        );

        dynamicFilterMap[tab.name] = dynamicFields;
      } catch (e) {
        console.error(
          `Failed to parse display_template for tab ${tab.name}:`,
          e
        );
      }
    });

    return dynamicFilterMap;
  };

  safeParse = (maybeJSON: any) => {
    if (typeof maybeJSON === 'string') {
      try {
        return JSON.parse(maybeJSON);
      } catch (e) {
        console.warn(' Failed to JSON‑parse:', maybeJSON, e);
      }
    }
    return maybeJSON || {};
  };

  renderTabs = () => {
    const { dashboardTab } = this.props;

    if (!Array.isArray(dashboardTab) || dashboardTab.length === 0) {
      return <div>No dashboard tabs available</div>;
    }
    return (
      <div className="workflow-inbox-tabs">
        {dashboardTab.map((tab) => (
          <IconButton
            key={tab.name}
            onClick={() => {
              this.handleTabChange(tab);
            }}
            className={`tab-button ${this.state.activeTab === tab.name ? 'active' : ''}`}
          >
            {tab.label || tab.name}
          </IconButton>
        ))}
      </div>
    );
  };

  primeCreatedAtUI() {
    const fd = this.filterDataRef.current;
    const hasSavedDate = (this.state.selectedFilter?.userFilter || []).some(
      (f: any) => f.type === 'date'
    );

    if (
      fd &&
      !this.state.didPrimeCreatedAt &&
      !hasSavedDate &&
      Array.isArray(fd.state.tabs) &&
      fd.state.tabs.length
    ) {
      fd.setState((s: any) => ({
        tabs: s.tabs.map((tab: any) =>
          tab.name === '_mo_created_at'
            ? { ...tab, value: 'Last 30 days' }
            : tab
        ),
      }));
      this.setState({ didPrimeCreatedAt: true, filterCount: 1 });
    }
  }

  prettyLabel = (rawKey: string) => {
    let key = rawKey.replace(/^_?mo_/, '').replace(/^_+/, '');

    if (key.includes('.desig_id')) key = key.split('.')[0];

    return key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
  };

  callDownloadDashboard = () => {
    const items = this.state.tableData?.length
      ? this.state.tableData
      : this.props.dashboardTabData || [];
    if (!items.length) return;
    const tabDetails =
      (this.props.dashboardTab || []).find(
        (t: any) => t.name === this.state.activeTab
      ) || {};

    const metrics = this.safeParse(tabDetails?.metrics);
    const keyDimension = this.safeParse(tabDetails?.key_dimension);

    const header: any = [];
    if (keyDimension) {
      header.push({
        name: keyDimension.name || '',
        label: tabDetails.label || '',
      });
    }
    Object.keys(metrics).forEach((k) => {
      const m = metrics[k];
      if (m?.field_name)
        header.push({
          name: m.field_name,
          label: m.label || m.field_name,
        });
    });

    const esc = (v: any) => JSON.stringify(v ?? '');
    const headerLabels = header.map((h: any) => esc(h.label));
    const lines = items.map((row: any) =>
      header
        .map((h: any, idx: any) => {
          if (idx === 0) return esc(this.getDimensionValue(tabDetails, row));
          return esc(row[h.name]);
        })
        .join(',')
    );

    const csvContent = [headerLabels.join(','), ...lines].join('\r\n');

    const fileNameBase = (this.props.reportDetails?.description || 'Dashboard')
      .replace(/^[\s_]+/, '')
      .split(' ')
      .join('_');

    const fileName = `${fileNameBase}_${moment().format('DD-MM-YYYY')}.csv`;
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  renderViews = () => {
    const { dashboardTab } = this.props;

    const viewOptions =
      dashboardTab?.map((tab: any) => ({
        name: tab.name,
        label: tab.label || tab.name,
      })) || [];

    return (
      <div className="views-search-wrapper">
        <div className="views-picky">
          <p>Views</p>
          <Picky
            options={viewOptions}
            value={this.state.selectedView}
            labelKey="label"
            valueKey="name"
            numberDisplayed={0}
            includeFilter={true}
            onChange={(val: any) => this.handleViewChange(val)}
            dropdownHeight={250}
          />
        </div>

        <ToggleButtonGroup
          value={this.state.viewMode}
          exclusive
          onChange={(_, val) => {
            if (!val) return;
            this.setState({ viewMode: val, page: 0, openFilter: true }, () => {
              this.persistDashboardState();
              this.fetchDataForCurrentView();
            });
          }}
          size="small"
        >
          <ToggleButton value="TEAM">Team</ToggleButton>
          <ToggleButton value="ME">Me</ToggleButton>
        </ToggleButtonGroup>
        <div className="workflow-inbox-filter-search">
          <Badge
            badgeContent={this.state.filterCount}
            classes={{
              badge: this.props.classes.badge,
              root: this.props.classes.root,
            }}
          >
            <IconButton
              disabled={isNull(this.state.headers)}
              onClick={() =>
                !isNull(this.state.headers) && this.handleChangeOpenFilter()
              }
              size="small"
            >
              <i className="fas fa-filter" />
            </IconButton>
          </Badge>

          <IconButton
            disabled={!this.state.tableData.length}
            onClick={this.callDownloadDashboard}
            size="small"
          >
            <i className="fas fa-download" />
          </IconButton>
        </div>
      </div>
    );
  };

  renderTable = () => {
    const { page, rowsPerPage, activeTab, selectedView } = this.state;
    const { dashboardTab, dashboardTabData } = this.props;

    if (!Array.isArray(dashboardTab) || dashboardTab.length === 0) {
      return null;
    }

    if (!dashboardTabData || dashboardTabData.length === 0) {
      return <div style={{ marginTop: '20px' }}>No data available</div>;
    }
    const tabName = activeTab || selectedView?.name || '';

    const tabDetails =
      (dashboardTab || []).find((t) => t.name === tabName) ||
      dashboardTab[0] ||
      {};
    const metricsObj: { [key: string]: any } =
      this.safeParse(tabDetails.metrics) || {};
    const keyDimension: { name?: string; label?: string } =
      this.safeParse(tabDetails.key_dimension) || {};

    const columnLabels: { [key: string]: string } = {};

    if (keyDimension.name) {
      columnLabels[keyDimension.name] = keyDimension.label || keyDimension.name;
    }

    Object.values(metricsObj).forEach((m: any) => {
      if (m?.field_name && m?.label) {
        columnLabels[m.field_name] = m.label;
      }
    });

    const keySet = dashboardTabData.reduce((set: Set<string>, row: any) => {
      Object.keys(row).forEach((k) => set.add(k));
      return set;
    }, new Set<string>());

    const columnDefinitions = Array.from(keySet)
      .filter((k: any) => !['_id', 'dimension'].includes(k))
      .map((key: any) => ({
        key: key,
        label: columnLabels[key] || this.prettyLabel(key),
      }));

    const paginatedData = dashboardTabData.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );

    return (
      <Paper className="paper-root overflowX">
        <Table className="table-wrapper">
          <TableHead>
            <TableRow className="tabel-head-wrapper">
              {columnDefinitions.map((col) => (
                <TableCell key={col.key as string} style={{ fontWeight: 600 }}>
                  {' '}
                  {/* Assert as string here */}
                  {col.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody className="tabel-body">
            {paginatedData.map((row: any, rowIdx: number) => (
              <TableRow
                key={rowIdx}
                onClick={() => this.handleRowClick(row)}
                style={{ cursor: 'pointer' }}
              >
                {columnDefinitions.map((col, idx) => {
                  const key = col.key;
                  const rawVal = row[key];

                  const firstCellStyle =
                    idx === 0
                      ? {
                          color: '#0d6efd',
                          textDecoration: 'underline',
                          cursor: 'pointer',
                        }
                      : {};

                  if (
                    typeof rawVal === 'object' &&
                    rawVal !== null &&
                    'desig_id' in rawVal
                  ) {
                    const name = this.getDesignationDisplayName(
                      rawVal.desig_id
                    );
                    return (
                      <TableCell key={key as string} style={firstCellStyle}>
                        {name || rawVal.desig_id}
                      </TableCell>
                    );
                  }

                  if (key.endsWith('.desig_id')) {
                    const id = typeof rawVal === 'string' ? rawVal : '';
                    const name = this.getDesignationDisplayName(id);
                    return (
                      <TableCell key={key as string} style={firstCellStyle}>
                        {name || id}
                      </TableCell>
                    );
                  }

                  if (typeof rawVal === 'object' && rawVal !== null) {
                    return (
                      <TableCell key={key as string} style={firstCellStyle}>
                        {Object.values(rawVal).join(', ')}
                      </TableCell>
                    );
                  }

                  if (
                    typeof rawVal === 'string' &&
                    /^\d{4}-\d{2}-\d{2}T/.test(rawVal)
                  ) {
                    return (
                      <TableCell key={key as string} style={firstCellStyle}>
                        {moment(rawVal).format('Do MMM YY HH:mm')}
                      </TableCell>
                    );
                  }

                  return (
                    <TableCell key={key as string} style={firstCellStyle}>
                      {rawVal ?? '—'}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>

          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[10, 25, 50]}
                count={dashboardTabData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={this.handleChangePage}
                onRowsPerPageChange={this.handleChangeRowsPerPage}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </Paper>
    );
  };
  render() {
    const { showInboxTable } = this.state;

    return (
      <div id="workflow-inbox-root">
        <div className="workflow-inbox-wrapper">
          {this.renderHeader()}
          {!showInboxTable && (
            <>
              {this.renderViews()}
              {this.state.openFilter &&
                !isNull(this.state.headers) &&
                Object.keys(this.props.reportDetails).length > 0 && (
                  <FilterData
                    ref={this.filterDataRef}
                    template={this.props.reportDetails}
                    applyFilter={this.handleFilterChange}
                    templateId={this.props.router.params.templateId}
                    passStructuredFilter={true}
                    initialDefaultFilters={dashboardDefaultFilters}
                    isDashboardContext={true}
                    userTeamDetails={this.props.userTeamDetails}
                    teamdesignations={this.props.teamdesignations}
                    selectedView={this.state.selectedView}
                  />
                )}
            </>
          )}

          <div className="workflow-inbox-content">{this.renderTable()}</div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  open: state.reportReducer.open,
  reportDetails: state.reportReducer.reportDetails,
  dashboardTab: state.reportReducer.dashboardTab,
  dashboardTabData: state.reportReducer.dashboardTabData,
  userTeamDetails: state.homeReducer.userTeamDetails,
  teamUserDetailsSuccess: state.homeReducer.teamUserDetailsSuccess,
  allReportee: state.reportReducer.allReportee,
  teamdesignations: state.reportReducer.teamdesignations,
});
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      getDashboardTab,
      getDashboardTabData,
      getReportDetails,
      getTeamUserDetails,
      clearDashboardData,
      getUserDesignationDetails,
      getMyAllReportee,
      resetErrorMessage,
      resetSuccessMessage,
      getTeamDesignations,
    },
    dispatch
  );

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Dashboard))
);

window.addEventListener('beforeunload', () => {
  sessionStorage.removeItem('reload-handled');
});
